import cn from 'classnames';
import React, { useEffect, useState } from 'react';

// REDUX
// STYLES
import { EDebugWinPresentationEvents } from '@Core/Win/States/WinPresentationStates';
import { IWinLevel } from '@GFTypes/GameStoreTypes';
import EventsCenter from '@Managers/Events/EventsCenter';
import { getBetState, getDebugWinPresentationModeStateAvailable } from '@Managers/Redux/AppState/AppState';
import { useAppSelector } from '@Managers/Redux/Hooks';
import styles from './WinMessages.scss';

const WinMessagesOption: React.FC<{ index: number; level: IWinLevel; onClick: Function; activeIndex: number | null }> = ({
    index,
    level,
    onClick,
    activeIndex
}) => {
    const gameStoreDebugWinPresentationModeStateAvailable = useAppSelector(getDebugWinPresentationModeStateAvailable);
    const gameStoreBetState = useAppSelector(getBetState);
    const [debugAvailable, setDebugAvailable] = useState(false);

    useEffect(() => {
        setDebugAvailable(gameStoreDebugWinPresentationModeStateAvailable);
    }, [gameStoreDebugWinPresentationModeStateAvailable]);

    const handleStartWinLevel = (level: any, index: number) => {
        if (!debugAvailable) return;
        onClick(index);

        const bet = gameStoreBetState.value.raw;
        const from = level.from;
        const to = level.to;

        let multiplier = Math.random() * (to - from) + from;
        multiplier = Math.round(multiplier * 2) / 2;

        if (multiplier >= to) multiplier = to - 0.5;
        if (multiplier < 0.5) multiplier = 0.5;

        if (level.name?.toLowerCase().includes('mega') && multiplier > 1000) {
            multiplier = Math.min(1000 + Math.random() * 500, 1500);
            multiplier = Math.round(multiplier * 2) / 2;
        }

        const winAmount = Math.floor(bet * multiplier);
        EventsCenter.emit(EDebugWinPresentationEvents.DEBUG_WINPRESENTATION_START, { bet, winAmount });
    };

    return (
        <div
            key={index}
            onClick={(e) => handleStartWinLevel(level, index)}
            className={cn(styles.winMessages_levelItem, activeIndex === index ? styles.clicked : null, { [styles.disabled]: !debugAvailable })}
        >
            {level.name || `${level.from} - ${level.to}`}
        </div>
    );
};

export default WinMessagesOption;
